import { createSlice } from "@reduxjs/toolkit";
import { ApiCallStatus, ApiResourceState, ResourceList } from "@myRedux/networkState";
import { RootState } from "@myRedux/store";
import { handleSliceRejectionDefault } from "@myRedux/handleSliceRejection";
import { SchoolDistrictResource } from "@myRedux/schoolDistrict/schoolDistrictSlice";
import { searchAsyncThunk } from "@myRedux/appAsyncThunkUtilities";
import { TeacherResource } from "./teacher";

const initialState = {
  status: ApiCallStatus.Idle,
  value: null
} as ApiResourceState<ResourceList<TeacherResource>>;

export const autocompleteSearchTeachersAsync = searchAsyncThunk<SchoolDistrictResource>('teacher/autocompleteSearchTeachers', 'teachers', 'lastname');

export const teacherAutocompleteSlice = createSlice({
  name: 'teacherAutocompleteSlice',
  initialState: initialState,
  reducers: {
    clearAutocompleteTeachers(state) {
      state.status = ApiCallStatus.Idle;
      state.value = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(autocompleteSearchTeachersAsync.pending, (state) => {
        state.status = ApiCallStatus.Loading;
      })
      .addCase(autocompleteSearchTeachersAsync.fulfilled, (state, action) => {
        state.status = ApiCallStatus.Succeeded;
        state.value = action.payload;
      })
      .addCase(autocompleteSearchTeachersAsync.rejected, (state, action) => {
        state.status = ApiCallStatus.Failed;
        state.value = null;
        handleSliceRejectionDefault(action);
      })
  },
});

export const selectAutocompleteTeachers = (state: RootState) => state.teacher.autocompleteTeachers;

const { actions, reducer } = teacherAutocompleteSlice;
export const { clearAutocompleteTeachers } = actions;
export default reducer;